import React from "react";
import { AlertTriangle } from "lucide-react";
import { Modal } from "./Modal";
import { Button } from "./Button";

interface Props { open: boolean; title: string; description?: React.ReactNode; confirmLabel?: string; danger?: boolean; busy?: boolean; onCancel: () => void; onConfirm: () => void; testId?: string }

export function ConfirmDialog({ open, title, description, confirmLabel = "Confirm", danger, busy, onCancel, onConfirm, testId = "confirm-dialog" }: Props) {
  return (
    <Modal open={open} onOpenChange={(o) => !o && onCancel()} title={title} className="max-w-md" testId={testId}
      footer={<><Button variant="secondary" onClick={onCancel} data-testid={`${testId}-cancel`}>Cancel</Button><Button variant={danger ? "danger" : "primary"} loading={busy} onClick={onConfirm} data-testid={`${testId}-confirm`}>{confirmLabel}</Button></>}>
      <div className="flex items-start gap-3">
        <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${danger ? "bg-rose-50 text-rose-600" : "bg-amber-50 text-amber-600"}`}><AlertTriangle className="h-5 w-5" /></span>
        <div className="text-sm text-slate-700">{description}</div>
      </div>
    </Modal>
  );
}
